import { Flex, FullscreenTakeover } from "@jsq/ds/core";
import { ProfileConflictResolver } from "~/pages/Compliance/CaseDetailsDrawer/Documents/DocumentManagement/DocumentDetailsRightSidebar/ProfileDetailsFormValues/ProfileConflictResolver";
import { DocumentsViewPanel } from "~/pages/Compliance/CaseDetailsDrawer/Documents/DocumentManagement/DocumentManagementDisplay/DocumentsViewPanel";
import { previewBody, previewPanel, rightPanel, rightPanelWrapper } from "./styles_vanilla.css";

export const ProfileResolverPreview = ({
  profileId,
  documentId,
  onClose,
}: {
  profileId: number;
  documentId: number;
  onClose: () => void;
}) => {
  return (
    <FullscreenTakeover.Body className={previewBody}>
      <Flex className={previewPanel}>
        <DocumentsViewPanel documentId={documentId} />
      </Flex>
      <Flex className={rightPanelWrapper}>
        <Flex className={rightPanel}>
          <ProfileConflictResolver
            documentId={documentId}
            profileId={profileId}
            onClose={onClose}
          />
        </Flex>
      </Flex>
    </FullscreenTakeover.Body>
  );
};
